module.exports = __webpack_public_path__ + "media/images/tutorial_header_pc3-04-1e90a671bfc35dc5e7d377f3f0c9623f.png";